import script from "./ReviewWriteComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewWriteComponent.vue?vue&type=script&setup=true&lang=js"

import "./ReviewWriteComponent.vue?vue&type=style&index=0&id=25ff0342&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ff0342"]])

export default __exports__